const reportTranslator = (textFromReport) => {
  const textArray = [
    {
      text: ["Date"],
      display: "ra.text.report.date",
    },
    {
      text: ["Name", "name"],
      display: "ra.text.report.name",
    },
    {
      text: ["Members"],
      display: "ra.text.report.members",
    },
    {
      text: ["Ranking", "Rank"],
      display: "ra.text.report.ranking",
    },
    {
      text: ["Revenue"],
      display: "ra.text.report.revenue",
    },
    {
      text: ["Revenue (THB)"],
      display: "ra.text.report.revenueTHB",
    },
    {
      text: ["Transactions", "Transaction", "Trans"],
      display: "ra.text.report.transaction",
    },
    {
      text: ["Transactions (THB)"],
      display: "ra.text.report.transactionTHB",
    },
    {
      text: ["Quantity (Units)", "Quantity (units)"],
      display: "ra.text.report.quantity",
    },
    {
      text: ["Total Price"],
      display: "ra.text.report.totalPrice",
    },
    {
      text: ["Discount"],
      display: "ra.text.report.discount",
    },
    {
      text: [
        "Total Revenue",
        "Total Revenue(THB)",
        "Total Revenue (THB)",
        "Total Revenues (THB)",
      ],
      display: "ra.text.report.totalRevenue",
    },
    {
      text: ["Cash"],
      display: "ra.text.report.cash",
    },
    {
      text: ["Transfer"],
      display: "ra.text.report.transfer",
    },
    {
      text: ["Credit", "Debit", "Credit/Debit"],
      display: "ra.text.report.credit",
    },
    {
      text: ["Name and Payment ID"],
      display: "ra.text.report.nameandPaymentID",
    },
    {
      text: ["Total Payment"],
      display: "ra.text.report.totalPayment",
    },

    {
      text: ["Payment Method"],
      display: "ra.text.report.paymentMethod",
    },
    {
      text: ["Phone"],
      display: "ra.text.report.phone",
    },
    {
      text: ["User"],
      display: "ra.text.report.user",
    },
    {
      text: ["Remark"],
      display: "ra.text.report.remark",
    },

    {
      text: ["Tier.", "Tier"],
      display: "ra.text.report.tier",
    },
    {
      text: ["LTV (THB)", "LTV(THB)", "LTV"],
      display: "ra.text.report.ltv",
    },
    {
      text: ["Frequent Category"],
      display: "ra.text.report.frequentCategory",
    },
    {
      text: ["Frequent Product"],
      display: "ra.text.report.frequentProduct",
    },
    {
      text: ["Expensive Category"],
      display: "ra.text.report.expensiveCategory",
    },
    {
      text: ["Expensive Product"],
      display: "ra.text.report.expensiveProduct",
    },
    {
      text: ["Most Frequent Category"],
      display: "ra.text.report.mostFrequentCategory",
    },
    {
      text: ["Most Frequent Product"],
      display: "ra.text.report.mostFrequentProduct",
    },
    {
      text: ["Most Expensive Category"],
      display: "ra.text.report.mostExpnsiveCategory",
    },
    {
      text: ["Most Expensive Product"],
      display: "ra.text.report.mostExpensiveProduct",
    },
    {
      text: ["Total Earn", "Total Earn (points)"],
      display: "ra.text.report.totalEarn",
    },
    {
      text: ["Total Redeem", "Total Redeem (points)"],
      display: "ra.text.report.totalRedeem",
    },
    {
      text: ["Total Remaining", "Total Remaining (points)"],
      display: "ra.text.report.totalRemaining",
    },
    {
      text: ["Total Members"],
      display: "ra.text.report.totalMembers",
    },
    {
      text: ["Total Walk-in"],
      display: "ra.text.report.totalWalkin",
    },
    {
      text: [
        "Total Quantity",
        "Total Quantity (Unit)",
        "Total Quantity (Units)",
        "Total Quantity (units)",
      ],
      display: "ra.text.report.totalQuantity",
    },
    {
      text: ["Total Transactions"],
      display: "ra.text.report.totalTransactions",
    },
    {
      text: ["Total Cash"],
      display: "ra.text.report.totalCash",
    },
    {
      text: ["Total Transfer"],
      display: "ra.text.report.totalTransfer",
    },
    {
      text: ["Total Credit/Debit"],
      display: "ra.text.report.totalCredit",
    },
    {
      text: ["Total LTV"],
      display: "ra.text.report.totalLTV",
    },
    {
      text: ["Total LTV (THB)", "Total LTV(THB)"],
      display: "ra.text.report.totalLTVTHB",
    },
    {
      text: ["Current Tier"],
      display: "ra.text.report.currentTier",
    },
    {
      text: ["Total Price", "Total Price (THB)"],
      display: "ra.text.report.totalPrice",
    },
    {
      text: ["Product name"],
      display: "ra.text.report.productName",
    },
    {
      text: ["Category name"],
      display: "ra.text.report.categoryName",
    },
    {
      text: ["Frequent"],
      display: "ra.text.report.frequent",
    },
    {
      text: ["Big spender"],
      display: "ra.text.report.bigSpender",
    },
    {
      text: ["Total Members", "Total Member"],
      display: "ra.text.report.totalMembers",
    },
    {
      text: ["Total Customers", "Total Customer"],
      display: "ra.text.report.totalCustomer",
    },
    {
      text: ["Product Code"],
      display: "ra.text.report.productCode",
    },
    {
      text: ["Product Name"],
      display: "ra.text.report.productName",
    },
    {
      text: ["Category"],
      display: "ra.text.report.category",
    },
  ];

  return textArray.find((text) => text.text.includes(textFromReport))?.display;
  // return textFromReport;
};

export default reportTranslator;
